module.exports = __webpack_public_path__ + "assets/images/05-active_ee40c4344c1774e2c0cd3aa8006ab20b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/exercise-1/05-active.png
// module id = 231
// module chunks = 0